import script from "./EditExamView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditExamView.vue?vue&type=script&setup=true&lang=ts"

import "./EditExamView.vue?vue&type=style&index=0&id=67fd18dd&scoped=true&lang=css"
import "./EditExamView.vue?vue&type=style&index=1&id=67fd18dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67fd18dd"]])

export default __exports__